<template>
    <div class="give-wrap">
        <!--  票券列表选择弹框 -->
        <a-modal
            title='票券选择'
            :width="880"
            :visible="visible"
            :confirmLoading="loading"
            @cancel="closeModal"
            @ok="handleCreate"
            >
            <a-spin :spinning="spinning">
                <div>
                    <a-form :form="form" layout="inline">
                        <a-form-item label="票券内部标识">
                            <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                        </a-form-item>
                        <a-form-item label="票券类型">
                            <a-select style="width: 106px" allowClear placeholder="请选择" v-decorator="['type']">
                                <a-select-option value="1">期限卡</a-select-option>
                                <a-select-option value="2">次卡</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="票券状态">
                            <a-select style="width: 106px" allowClear placeholder="请选择" v-decorator="['isOnShelves']">
                                <a-select-option :value="1">上架中</a-select-option>
                                <a-select-option :value="0">已下架</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-button @click="search" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form>
                    <a-table style="word-break:break-all;" class="mt16" :scroll="{ y: 360 }" bordered :columns="columns" :dataSource="dataSource" :pagination="false" :rowSelection="{onChange: onSelectChange, selectedRowKeys: selectedTicketsRowKeys}" :rowKey="record => record.ticketId" >
                        <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                        <span slot="type" slot-scope="a">{{['', '期限卡', '次卡'][a]}}</span>
                        <span slot="isOnShelves" slot-scope="a">{{['已下架', '上架中'][Number(a)]}}</span>
                    </a-table>
                    <div class="mt16 text-fail">您共选择了： {{selectedTicketsRowKeys.length}} 个票券</div>
                </div>
            </a-spin>
        </a-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    /**
     * 票券选择弹框组件
     * 
     * @prop {Boolean} visible 控制弹窗是否显示
     *
     * @func closeModal 通知父组件关闭弹窗
     *
     */
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            width: 80,
            scopedSlots: { customRender: "index" }
        },
        {
            title: "票券内部标识",
            dataIndex: "name",
        },
        {
            title: "类型",
            dataIndex: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
        },
        {
            title: "票券状态",
            dataIndex: "isOnShelves",
            scopedSlots: { customRender: "isOnShelves" },
            width: 150,
        },
        {
            title: "售卖价/元",
            dataIndex: "sellShowPrice",
            width: 150,
        }
    ];
    export default {
        name: "ticket-list",
        zh: "门店票列表选择弹框组件",
        data() {
            return {
                form: this.$form.createForm(this),
                columns,
                dataSource: [],
                selectedTicketsRowKeys: [],
                shopList: [],
                visible: false,
                ticketShopId: undefined,
                type: 1,
                flatData: [],
                loading: false,
                spinning: false,
                shopTicketList: []
            };
        },
        props: {
            ticketList: {type: Array},
            selectedRowKeys: {type: Array, default: () => []},
        },
        computed: {...mapGetters(["shopId"])},
        watch: {
            visible(val) {
                if(val) {
                    this.type = 1;
                    this.selectedTicketsRowKeys = this.$utils.deepClone(this.selectedRowKeys);
                    this.ticketList.map(item => {
                        item.ticketId = item.ticketTemplateId;
                        item.targetId = item.ticketTemplateId;
                        return item;
                    })
                    this.dataSource = this.$utils.deepClone(this.ticketList);
                    this.flatData = this.$utils.deepClone(this.ticketList);
                    this.handleReset();
                }
            }
        },
        methods: {
            handleReset () {
                this.form.resetFields();
                this.search();
            },
            handleCreate() {
                this.loading = true;
                let selectedTicketsRows = [];
                let list = this.ticketList.concat(this.shopTicketList);
                list.forEach(item => {
                    this.selectedTicketsRowKeys.forEach(key => {
                        if(item && item.targetId == key) {
                            selectedTicketsRows.push(item)
                        }
                    })
                })
                this.$emit('confirm', {
                    selectedTicketsRowKeys: this.selectedTicketsRowKeys, 
                    selectedTicketsRows: selectedTicketsRows
                });
                this.visible = false;
                setTimeout(() => {this.selectedTicketsRowKeys = [];this.loading = false}, 100);
            },
            onSelectChange(selectedRowKeys, dateString) {
                this.selectedTicketsRowKeys = selectedRowKeys;
            }, 
            closeModal() {
                this.visible = false;
            },
            search() {
                let flatData = this.flatData;
                let { name, type, isOnShelves } = this.form.getFieldsValue();
                this.dataSource = flatData.filter(item => {
                    let ticketNameCode = Boolean(name) ? new RegExp(name).test(String(item.name)) : true;
                    let ticketTypeCode = type ? item.type == type : true;
                    let stateCode;
                    if (typeof isOnShelves === 'undefined' || isOnShelves === null && !Boolean(isOnShelves)) {
                        stateCode = true;
                    } else {
                        stateCode = item.isOnShelves === Boolean(isOnShelves);
                    }
                    return (ticketNameCode && ticketTypeCode && stateCode);
                });
            },
        },
        mounted() {
        }
    };
</script>

<style lang="scss">

</style>